module.exports = __webpack_public_path__ + "img/Monte_Kope_41.95d2f85d.jpg";